<template>
  <round :device="device">
    <div>
      <img :src="icon" style="height: 65px;"/>
    </div>
    <div slot="footer" class="footer">
      <div>
        <div>
          <span class="radius" purple @click="changeColor('deeppink')"
                :selected="device.state && device.state.color==='deeppink'"></span>
        </div>
        <div>
          <span>紫色</span>
        </div>
      </div>
      <div @click="changeColor('color')">
        <div>
          <img src="../assets/images/device/d-zdy.png"/>
        </div>
        <div>
          <span>变换</span>
        </div>
      </div>
      <div>
        <div>
          <span class="radius" more @click="showMore">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </div>
        <div>
          <span>更多</span>
        </div>
      </div>
    </div>
  </round>
</template>
<script>
import Round from './Round'
import { Message } from 'element-ui'
import api from '../model/device'

export default {
  name: 'Colorbar',
  data () {
    return {}
  },
  computed: {
    icon () {
      if (this.device.state.state) {
        return require('../assets/images/device/light/device_colorbar_e.png')
      } else {
        return require('../assets/images/device/light/device_colorbar.png')
      }
    }
  },
  props: {
    device: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  },
  components: {
    Round
  },
  methods: {
    async changeColor (color) {
      try {
        await api.singleControl(this.device, color)
      } catch (e) {
        Message.error(e.message)
      }
    },
    showMore () {
      this.$router.push({ name: 'colorbarDetail', params: { id: this.device.id, device: this.device } })
    }
  }
}
</script>
<style scoped lang="less">
.round {
  .colorbar {

  }
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    img {
      width: 45px;
      cursor: pointer;
    }
    .radius {
      display: inline-block;
      width: 45px;
      height: 45px;
      cursor: pointer;
      border-radius: 50%;
    }

    .radius[purple] {
      background-color: deeppink;
    }

    .radius[more] {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 5px 16px 2px rgba(85, 85, 85, 0.08);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 4px;
    }

    .radius[more] > span {
      display: inline-block;
      background: rgba(85, 85, 85, 1);
      border-radius: 50%;
      height: 4px;
      width: 4px;
      margin-right: 4px;
    }

    .radius[more] > span:last-child {
      margin-right: 0;
    }

    .radius[selected] {
      width: 41px;
      height: 41px;
      border: 2px solid #e5e5e5;
    }
  }
}
</style>
